import { compose } from 'redux';
import { rest } from '@updater/redux-http-request';
import { ENVIRONMENT } from '../../environment';
import { addUpdHeaders } from './headers';

const { url: baseUrl, version } = ENVIRONMENT.endpoints.api;

export const requestUpdRestApi = compose(
  addUpdHeaders,
  rest.request({
    baseUrl: () => `${baseUrl}/${version}`,
  })
);

export const createUpdResourceFacade = resource =>
  rest.createResourceFacade(resource, requestUpdRestApi);
